var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Banner from "@atlaskit/banner";
import { Code } from "@atlaskit/code";
import WarningIcon from "@atlaskit/icon/glyph/warning";
import { Card, isSufficientPermission, Link, Permission, withFeatureFlag, } from "@atlassiansox/microscopekit";
import _ from "lodash";
import querystring from "querystring";
import React from "react";
import styled from "styled-components"; // tslint:disable-line
export var localPanelUrl = "http://localhost:3001";
var statlasUrl = "https://statlas.prod.atl-paas.net";
var microscopeUrl = "https://microscope.prod.atl-paas.net";
var ssamUrl = "https://ssam.prod.atl-paas.net";
var apiUrls = {
    ddev: "https://manager-service.ap-southeast-2.dev.atl-paas.net",
    "dev-west2": "https://manager-service.us-west-2.dev.atl-paas.net",
    "adev-west2": "https://manager-service--app.us-west-2.dev.atl-paas.net",
    "stg-west2": "https://manager-service.us-west-2.staging.atl-paas.net",
    "prod-west2": "https://manager-service.us-west-2.prod.atl-paas.net",
    local: "http://localhost:3000",
    test: "",
};
export var getApiUrl = function () {
    var environment = process.env.REACT_APP_ENV || "local";
    return apiUrls[environment];
};
export var cleanMicrosDeploymentInfo = function (data) {
    var _a, _b, _c;
    return ((_c = ((_b = (_a = data.shard) === null || _a === void 0 ? void 0 : _a.environments) !== null && _b !== void 0 ? _b : []).items) !== null && _c !== void 0 ? _c : []).map(function (i) {
        var _a, _b, _c, _d;
        return ({
            env: i.name,
            stacks: {
                stable: !!((_b = (_a = i.deployments) === null || _a === void 0 ? void 0 : _a.stable) === null || _b === void 0 ? void 0 : _b.id),
                persistent: ((_d = (_c = i.deployments) === null || _c === void 0 ? void 0 : _c.persistent) !== null && _d !== void 0 ? _d : []).length > 0,
            },
        });
    });
};
export var deploymentUrlFor = function (panelName, envType) {
    var urls = {
        prod: statlasUrl + "/mspanelsox-" + panelName,
        staging: statlasUrl + "/mspanel-" + panelName,
        local: localPanelUrl,
    };
    return urls[envType];
};
export var domainNameForDeployment = function (envType) {
    return envType === "local" ? localPanelUrl : statlasUrl;
};
export var hasDeployment = function (panelId, deploymentSource) {
    var url = deploymentUrlFor(panelId, deploymentSource);
    return fetch(url + "/index.html")
        .then(function (res) { return res.status === 200; })
        .catch(function () { return false; });
};
export var serviceUrl = function (service) {
    return microscopeUrl + "/services/" + service;
};
export var ssamContainerUrl = function (containerName) {
    return ssamUrl + "/access/containers/" + containerName;
};
export var avatarUrl = function (username) {
    return "https://staff-avatars.prod.atl-paas.net/avatar/" + username + "/?size=small";
};
export var directoryUrl = function (username) {
    return "https://directory.prod.atl-paas.net/employees/" + username;
};
var envType = function (env) {
    return env.includes("dev") ? "dev" : env.includes("stg") ? "staging" : "prod";
};
export var groupEnvironmentsByType = function (microsEnvironments) {
    var envs = _(microsEnvironments)
        .filter(function (e) { return e.stacks.stable || e.stacks.persistent; })
        .map(function (e) { return e.env; })
        .map(function (e) { return ({
        label: e,
        value: e,
        envType: envType(e),
    }); })
        .groupBy("envType")
        .value();
    return _(envs)
        .keys()
        .sortBy(function (e) { return ["dev", "staging", "prod"].indexOf(e); })
        .map(function (v) { return ({
        label: v,
        options: envs[v].map(function (v) { return ({ label: v.label, value: v.value }); }),
    }); })
        .value();
};
export var hasLocalDevPermission = function (service, panel) {
    var isServiceAdmin = isSufficientPermission(service.currentUserPermission, Permission.Write);
    var isPanelAdmin = isSufficientPermission(panel.currentUserPermission, Permission.Write);
    return isServiceAdmin && isPanelAdmin;
};
export var parseQuery = function (q) {
    return querystring.parse(q.startsWith("?") ? q.slice(1) : q);
};
export var isChromeless = function () {
    return window.sessionStorage.getItem("chromeless") === "1";
};
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 auto;\n  max-width: 600px;\n  text-align: center;\n"], ["\n  margin: 0 auto;\n  max-width: 600px;\n  text-align: center;\n"])));
export var CenteredMessage = function (props) { return (React.createElement(Wrapper, null,
    React.createElement(Card, null, props.children))); };
var BLOG_LINK = "https://hello.atlassian.net/wiki/x/rfTS1Q";
var PanelsMigrationBannerView = function () { return (React.createElement(Banner, { appearance: "warning", icon: React.createElement(WarningIcon, { label: "", secondaryColor: "inherit" }) },
    "Hey Friend! We are in the midst of transitioning panels from Microscope to Governator.",
    " ",
    React.createElement("a", { target: "_blank", href: BLOG_LINK }, "Click here to read more about this transition"),
    ".")); };
var PanelsMigrationBanner = withFeatureFlag("mpgBanner")(PanelsMigrationBannerView);
export var withPanelsMigrationBanner = function (WrappedComponent) { return function (props) { return (React.createElement(React.Fragment, null,
    React.createElement(PanelsMigrationBanner, null),
    React.createElement(WrappedComponent, __assign({}, props)))); }; };
var ErrWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
export var ProxyErrorMsg = function (props) { return (React.createElement(ErrWrapper, null,
    React.createElement("span", null,
        "path: ",
        props.url),
    React.createElement("span", null,
        "method: ",
        props.method),
    React.createElement("span", null,
        "Status code: ",
        props.status),
    React.createElement("span", null,
        "Reason: ",
        props.reason))); };
export var ERROR_MESSAGES = {
    SERVICE_LOAD_ERROR: function (serviceId) { return (React.createElement(CenteredMessage, null,
        "Sorry we failed to load the information on the service",
        " ",
        React.createElement(Code, { language: "text", text: serviceId }),
        ". Please try loading again")); },
    PANEL_LOAD_ERROR: function (panelId) { return (React.createElement(CenteredMessage, null,
        "Sorry we failed to load the information for the panel",
        " ",
        React.createElement(Code, { language: "text", text: panelId }),
        ". Please try loading again")); },
    SERVICE_NOT_FOUND: function (serviceId) { return (React.createElement(CenteredMessage, null,
        "The service ",
        React.createElement(Code, { language: "text", text: serviceId }),
        " doesn't seem to exist. Please check if Microscope has an entry for the service at",
        " ",
        React.createElement(Link, { to: serviceUrl(serviceId), title: serviceUrl(serviceId) }))); },
    PANEL_NOT_FOUND: function (panelId) { return (React.createElement(CenteredMessage, null,
        "The panel you are trying to load doesn't seem to exist. Please check if microscope entry for the panel exits at",
        " ",
        React.createElement(Link, { to: serviceUrl(panelId), title: serviceUrl(panelId) }))); },
    PANEL_NOT_INSTALLED: function (serviceId, panelId) { return (React.createElement(CenteredMessage, null,
        "Panel ",
        panelId,
        " is not installed on Service ",
        serviceId)); },
    NO_PANEL_PERMISSION: function (serviceId, panelId, ssamContainerId) { return (React.createElement(CenteredMessage, null,
        React.createElement("p", null,
            "You don't have permission to access panel",
            " ",
            React.createElement(Code, { language: "text", text: panelId }),
            " on service",
            " ",
            React.createElement(Code, { language: "text", text: serviceId }),
            ". Please make sure you are added in the access group named",
            " ",
            React.createElement(Code, { language: "text", text: panelId }),
            " in the",
            " ",
            React.createElement(Link, { to: ssamContainerUrl(ssamContainerId), title: "SSAM container" }),
            " ",
            "for the service ",
            React.createElement(Code, { language: "text", text: serviceId }),
            "."),
        React.createElement("p", null, "It may take up to 15 minutes for the permissions to sync. If you just got added to the access group, check back in 15 minutes please."))); },
    NO_ENVIRONMENTS: function (serviceId) { return (React.createElement(CenteredMessage, null,
        "Service ",
        React.createElement(Code, { language: "text", text: serviceId }),
        " doesn't have any active deployment on any environments. Come back here after you deploy it in an environment.")); },
};
var templateObject_1, templateObject_2;
